export default {
  indigenousAndProtectedAreas: {
"title": "Zones autochtones et protégées",
"titleTT": "Tous les rapports de l'exploitation sont vérifiés s'ils se trouvent à l'intérieur d'une zone protégée ou autochtone",
"subTitle": "Toutes les exploitations agricoles du rapport sont vérifiées si elles se trouvent à l'intérieur de zones protégées ou autochtones en",
"search": "Rechercher",
"producer": "Producteur",
"producerTT": "Sélectionnez le nom du producteur pour filtrer",
"productionPlaceAndFarmId": "Lieu de production (Exploitation) et ID d'exploitation",
"producerName": "Nom du producteur",
"addressOfProduction": "Adresse de production",
"area": "Superficie (ha)",
"interceptsProtectedArea": "Intercepte la zone protégée",
"interceptsIndigenousArea": "Intercepte la zone autochtone",
"riskMitigation": "Atténuation des risques",
"attachOneRiskMitigation": "Joindre un document d'atténuation des risques pour toutes les exploitations non conformes",
"removeAllFlaggedFarms": "Supprimer toutes les exploitations signalées",
"riskMitigationTitle": "Fournir un nouveau statut",
"removeAllFlaggedFarmsTT": "Ce bouton supprimera toutes les exploitations dont le statut est 'Oui' dans les colonnes 'Intercepte la zone protégée' et 'Intercepte la zone autochtone'",
"pleaseSelectManually": "Veuillez sélectionner le statut atténué manuellement.",
"attachFile": "Joindre un fichier",
"comments": "Commentaires",
"noInvasionOfProtectedAreas": "Pas d'invasion des zones protégées",
"manuallyMitigated": "Atténué manuellement",
"actions": "Actes",
}
};